import { Framework } from '@/framework/instance';
import { Stage } from '@/framework/plugins';

/**
 * 舞台快捷操作
 */
export class QuickStageOperate extends Framework {
    private quickOperateEvent = 'stage-quick-event';

    /**
     * 快捷操作
     */
    onQuickClick(fn: (type: string, isToggleMenu?: boolean) => void) {
        return this.framework.events.on(this.quickOperateEvent, fn);
    }

    /**
     * 触发快捷操作
     */
    emitQuickClick(type: string, isToggleMenu?: boolean) {
        this.framework.events.emit(this.quickOperateEvent, type, isToggleMenu);
        return this;
    }

    scrollToActiveStage() {
        this.framework.getInstance(Stage).scrollToActiveStage();
        return this;
    }

    delete(stageIndex) {
        this.framework.getInstance(Stage).delete(stageIndex);
        return this;
    }

    clone(stageIndex) {
        this.framework.getInstance(Stage).clone(stageIndex);
        return this;
    }

    create(stageIndex, incomeExtraInfo, inheritBgInfo, masterPage) {
        this.framework.getInstance(Stage).create(stageIndex, incomeExtraInfo, inheritBgInfo, masterPage);
        return this;
    }

    swapStages(stagesIndex: number[], destIndex: number, sourceIndex: number) {
        this.framework.getInstance(Stage).swapStages(stagesIndex, destIndex, sourceIndex);
        return this;
    }

    up() {
        const activeIndex = this.framework.stage.getActiveStageIndex();
        if (activeIndex === 0) return;
        const isLongImageMode = this.framework.stage.isLongImageMode();
        if (isLongImageMode) {
            this.swapStages([activeIndex], activeIndex - 1, activeIndex).scrollToActiveStage();
        } else {
            this.framework.stage.setActiveStageIndex(activeIndex - 1);
            this.scrollToActiveStage();
        }
        return this;
    }

    down() {
        const activeIndex = this.framework.stage.getActiveStageIndex();
        const count = this.framework.getRenderStageLength();
        if (activeIndex === count - 1) return;
        const isLongImageMode = this.framework.stage.isLongImageMode();
        if (isLongImageMode) {
            this.swapStages([activeIndex], activeIndex + 1, activeIndex).scrollToActiveStage();
        } else {
            this.framework.stage.setActiveStageIndex(activeIndex + 1);
            this.scrollToActiveStage();
        }
        return this;
    }

    setStageSelection() {
        const stageIndex = this.framework.stage.getActiveStageIndex();
        this.framework.stage.setStageSelection([stageIndex]);
        this.framework.events.emitStageSelectionChange([stageIndex]);
        return this;
    }
}
